const emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
const phonePattern = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

export const requiredValidationRule = (label: string, value: any): string | null => {
  if (value instanceof Date) {
    return null;
  }
  if (!!value && (value + "").length > 0) {
    return null;
  }
  return `${label} is required`;
};

export const phoneValidationRule = (label: string, value: any): string | null => {
  if (value && phonePattern.test(value as string)) {
    return null;
  }
  return `${label} is invalid`;
};

export const emailValidationRule = (label: string, value: any): string | null => {
  if (value && emailRegexp.test(value as string)) {
    return null;
  }
  return `${label} is invalid`;
};

export const requiredEmailValidationRule = (label: string, value: any): string | null => {
  const requiredError = requiredValidationRule(label, value);
  if (requiredError) {
    return requiredError;
  } else if (value && emailRegexp.test(value as string)) {
    return null;
  }
  return `${label} is invalid`;
};
